import { useTranslation } from 'react-i18next'
import { FaLine } from 'react-icons/fa'
import { FcGoogle } from 'react-icons/fc'
import { Link } from 'react-router-dom'
import useGoogleAuthRedirect from '../../hooks/useGoogleAuthRedirect'

const CreativePark = () => {
    const { t } = useTranslation()
    useGoogleAuthRedirect()

    return (
        <>
            <div className="light-theme">
                <div className="section1 position-relative">
                    <div className="overlay padding text-center h-100 d-flex flex-column justify-content-center">
                        <div className="container">
                            <div className="login-box mx-auto">
                                <img src={require('../../assets/images/Limits_Creative-Park-Light.png')} alt="" className="img-fluid mb-4" style={{ "width": "228px" }} />
                                <h4 className='mb-3 fw-semibold'>{t('A FUN PLACE FOR CREATORS, LEARNERS, & FAMILIES TO EXPLORE CREATIVITY!')}</h4>

                                <div className='mt-5'>
                                    <Link to={'/park/user-type'} className='btn btn1 btn-orange w-100'>Create an Account | 新規登録</Link>
                                </div>
                                <div className='mt-3'>
                                    <Link to={'/park/signin'} className='btn btn1 w-100'>Login | ログインはこちら</Link>
                                </div>
                                <div className='mt-3'>
                                    <Link to={`${process.env.REACT_APP_API_URL}/auth/google?type=park`} target='_parent' className='btn btn1 btn-border w-100'><FcGoogle className='fs-2 me-1' /> <span className='align-middle'>Continue with Google</span></Link>
                                </div>
                                <div className='mt-3'>
                                    <Link to={`${process.env.REACT_APP_API_URL}/auth/line?type=park`} target='_parent' className='btn btn1 btn-border w-100'><FaLine className='fs-2 me-1' style={{color: "#06C755"}} /> <span className='align-middle'>Continue with LINE</span></Link>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreativePark
